import React from 'react';

export default function MultiSelect() {
  return (
    <React.Fragment>
      It's a MultiSelect!
    </React.Fragment>
  );
}
